import type { FormValues, FormHolidayValue } from '../../types';
import { HOLIDAY_NAME_PREFIX, HOLIDAY_FREQUENCY_PREFIX, HOLIDAY_DATE_PREFIX } from '../constants';

export const getFormHolidayValuesById = (
	fieldId: number,
	formData: FormValues,
): FormHolidayValue => {
	const name = formData[`${HOLIDAY_NAME_PREFIX}${fieldId}`];
	const iso8601Date = formData[`${HOLIDAY_DATE_PREFIX}${fieldId}`];
	const frequency = formData[`${HOLIDAY_FREQUENCY_PREFIX}${fieldId}`];
	return {
		fieldId,
		name,
		iso8601Date,
		isRecurring: frequency?.value,
	};
};
